import { Box, Paper, Typography } from '@mui/material';
import { ItemWithId } from 'services/constants/types';
import { PaginationBlock } from 'ui/PaginationBlock';
import { PAGE_SIZE } from 'services/constants/env';
import { TEasTableWithFilterProps } from './types';
import { EasTable } from '../EasTable';
import { EasTableFilterPanel } from './EasTableFilterPanel';

export const EasTableWithFilter = <T extends ItemWithId>({
	tableStructure,
	items,
	itemsIsLoading,
	handleAction,
	handleLink,
	skeletonRows,
	highlightedRow,
	children,
	filterChildren,
	name,
	showButtons,
	minWidth = 400,
}: TEasTableWithFilterProps<T>) => {
	return (
		<Box>
			<Paper
				sx={{
					overflowX: 'auto',
				}}
			>
				<Box sx={{ width: 'auto', minWidth }}>
					<Box sx={{ borderRadius: '12px' }}>
						{children && (
							<Box
								sx={{
									backgroundColor: 'primary.light',
									p: 0.5,
								}}
							>
								{children}
							</Box>
						)}
						<EasTableFilterPanel tableStructure={tableStructure} loading={itemsIsLoading}>
							{filterChildren}
						</EasTableFilterPanel>
						<EasTable<T>
							tableStructure={tableStructure}
							items={items?.data ?? null}
							itemsIsLoading={itemsIsLoading}
							handleAction={handleAction}
							handleLink={handleLink}
							skeletonRows={skeletonRows}
							highlightedRow={highlightedRow}
							name={name}
							showButtons={showButtons}
						/>
					</Box>
				</Box>
			</Paper>
			<Box
				sx={{
					padding: '0 20px 20px 20px',
					display: 'flex',
					justifyContent: 'space-between',
				}}
			>
				<PaginationBlock total={items?.totalCount ?? 0} isLoading={itemsIsLoading} />
				{!!items?.totalCount && (
					<Box
						sx={{
							pt: '20px',
							display: 'flex',
							flexDirection: 'row',
						}}
					>
						<Typography
							sx={{
								fontSize: '1rem',
								color: '#555',
							}}
						>
							{items?.totalCount ? `Total items: ` : ''}
						</Typography>
						&nbsp;
						<Typography
							sx={{
								fontSize: '1rem',
								fontWeight: 'bold',
								color: 'primary.main',
							}}
						>
							{items?.totalCount ? `${String(items?.totalCount ?? '')} ` : 'No data found'}
						</Typography>
					</Box>
				)}
			</Box>
		</Box>
	);
};
